export function pickSupplierUnitPrice(product, supplierId) {
    if (!product || !Array.isArray(product.supplier_details) || product.supplier_details.length === 0) {
        return null;
    }
    if (supplierId) {
        const match = product.supplier_details.find(s => s && s.supplier_id === supplierId);
        if (match && typeof match.unit_price === 'number') return match.unit_price;
    }
    const def = product.supplier_details.find(s => s && s.is_default === true);
    if (def && typeof def.unit_price === 'number') return def.unit_price;
    return null;
}

export function pickSupplierPartNumber(product, supplierId) {
    if (!product || !Array.isArray(product.supplier_details) || product.supplier_details.length === 0) {
        return '';
    }
    if (supplierId) {
        const match = product.supplier_details.find(s => s && s.supplier_id === supplierId);
        if (match && typeof match.supplier_part_number === 'string' && match.supplier_part_number) {
            return match.supplier_part_number;
        }
    }
    const def = product.supplier_details.find(s => s && s.is_default === true);
    if (def && typeof def.supplier_part_number === 'string' && def.supplier_part_number) {
        return def.supplier_part_number;
    }
    return '';
}

// The wording the supplier knows the item by ("Supplier item description (shown on PO)"
// on the product's supplier card). Same precedence as the part number: the PO's
// supplier first, then the default supplier; blank when neither has one.
export function pickSupplierItemDescription(product, supplierId) {
    if (!product || !Array.isArray(product.supplier_details) || product.supplier_details.length === 0) {
        return '';
    }
    if (supplierId) {
        const match = product.supplier_details.find(s => s && s.supplier_id === supplierId);
        if (match && typeof match.item_description === 'string' && match.item_description.trim()) {
            return match.item_description.trim();
        }
    }
    const def = product.supplier_details.find(s => s && s.is_default === true);
    if (def && typeof def.item_description === 'string' && def.item_description.trim()) {
        return def.item_description.trim();
    }
    return '';
}

export function applySupplierDetails(products, supplierId) {
    if (!Array.isArray(products)) return [];
    return products.map(p => Object.assign({}, p, {
        cost_price: pickSupplierUnitPrice(p, supplierId),
        supplier_product_code: pickSupplierPartNumber(p, supplierId),
        supplier_item_description: pickSupplierItemDescription(p, supplierId),
    }));
}

export const applySupplierUnitPrice = applySupplierDetails;
